import React, { useEffect, useRef, useState } from "react";
import { api } from "@/services/api";
import axios from "axios";
import ShimmerEffect from "@/components/Shimmer";

import { Container } from "./styles";

export const NotificationConsumer = () => {
	const button = useRef(null);
	const notificatioActive = localStorage.getItem("@notification-active");
	const [load, setLoad] = useState(false);
	const [data, setData] = useState(null);
	const loadElements = [];

	for (let index = 0; index < 6; index++) {
		loadElements.push(index);
	}

	useEffect(() => {
		if (button) {
			button.current.addEventListener("click", () =>
				// eslint-disable-next-line no-undef
				initFirebaseMessagingRegistration(),
			);
		}
	}, [button]);

	useEffect(() => {
		const CancelToken = axios.CancelToken; // instância do CancelToken
		const source = CancelToken.source(); // instância do source, onde está contido o token de cancelamento

		const loadData = () => {
			setLoad(true);

			api.get("consumer/notifications", {
				cancelToken: source.token,
				params: { type: "coupons" },
			})
				.then((res) => {
					setData(res?.data);
				})
				.catch((error) => {
					console.warn({ endPoint: "consumer/notifications", error });
				})
				.finally(() => setLoad(false));
		};

		loadData();

		// retorna uma função com a finalidade fazer o cancelamento
		return () => {
			source.cancel();
		};
	}, []);

	return (
		<Container>
			<aside className='d-none d-lg-block'>
				<img
					loading='lazy'
					className='img-responsive d-none d-lg-block m-auto'
					src={require("@/assets/img/cao-e-gato-consumidor.png").default}
					alt='cao e gato'
				/>
			</aside>

			<section>
				<header>
					<h2>Notificações</h2>
					<button
						style={{
							opacity: notificatioActive === "0" ? 1 : 0,
						}}
						ref={button}
						id='btn-nft-enable'>
						Permitir envio de Notificação
					</button>
				</header>

				<ul className='cupons'>
					{data?.notifications?.map((notification, i) => (
						<li key={i}>
							<header>
								<p className='cupomSerie'>
									{notification.title}
								</p>
								<p className='cupomDate'>{notification.date}</p>
							</header>
							<div className='cupomInfo'>
								<p>{notification.body}</p>
							</div>
						</li>
					))}

					{load &&
						loadElements?.map((_, index) => (
							<li key={index}>
								<header>
									<ShimmerEffect width={150} height={20} />
									<ShimmerEffect
										style={{ margin: "4px 0" }}
										width={150}
										height={20}
									/>
								</header>
								<div>
									<ShimmerEffect width={150} height={20} />
								</div>
							</li>
						))}
				</ul>
			</section>
		</Container>
	);
};

export default NotificationConsumer;
